import { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const nf = (n) => (n || 0).toLocaleString("de-DE");
const de = (iso) => iso.split("-").reverse().join(".");
const shiftYear = (iso, d) => `${parseInt(iso.slice(0, 4)) + d}${iso.slice(4)}`;

const METRICS = [
  ["persons", "Personen", nf],
  ["rooms", "Zimmer belegt", nf],
  ["room_nights", "Zimmernächte", nf],
  ["bookings", "Buchungen", nf],
  ["revenue", "Umsatz (anteilig)", euro],
];

export const PeriodCompareCard = () => {
  const y = new Date().getFullYear();
  const [start, setStart] = useState(`${y}-10-12`);
  const [end, setEnd] = useState(`${y}-10-25`);
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");

  const load = async () => {
    setErr("");
    try {
      const { data } = await api.get("/stats/period-compare", {
        params: { start, end, compare_start: shiftYear(start, -1), compare_end: shiftYear(end, -1) },
      });
      setRes(data);
    } catch (e) { setErr(e.response?.data?.detail || "Fehler beim Laden"); }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="msb-card" data-testid="period-compare-card">
      <h3 className="text-lg font-semibold" style={{ fontFamily: "'Work Sans',sans-serif" }}>Zeitraum-Vergleich mit Vorjahr</h3>
      <p className="text-xs text-muted-foreground mb-4">Zählt alle Gäste, die im Zeitraum mindestens eine Nacht da waren (ohne Stornos). Umsatz anteilig nach Nächten im Zeitraum.</p>
      <div className="flex flex-wrap items-end gap-3 mb-4">
        <div><div className="text-xs text-muted-foreground">Von</div><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="compare-start-input" /></div>
        <div><div className="text-xs text-muted-foreground">Bis</div><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="compare-end-input" /></div>
        <Button onClick={load} className="rounded-xl" data-testid="compare-run-btn">Vergleichen</Button>
      </div>
      {err && <div className="text-sm text-destructive mb-2" data-testid="compare-error">{err}</div>}
      {res && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="compare-table">
            <thead className="text-left text-muted-foreground">
              <tr><th className="py-2 pr-3"></th>
                <th className="pr-3">{de(res.b.start)} – {de(res.b.end)}</th>
                <th className="pr-3">{de(res.a.start)} – {de(res.a.end)}</th>
                <th>Differenz</th></tr>
            </thead>
            <tbody>
              {METRICS.map(([k, label, f]) => {
                const diff = (res.a[k] || 0) - (res.b[k] || 0);
                return (
                  <tr key={k} className="border-t" data-testid={`compare-row-${k}`}>
                    <td className="py-2 pr-3 font-medium">{label}</td>
                    <td className="pr-3">{f(res.b[k])}</td>
                    <td className="pr-3 font-semibold">{f(res.a[k])}</td>
                    <td className={diff > 0 ? "text-green-700" : diff < 0 ? "text-red-700" : ""}>{diff > 0 ? "+" : ""}{f(diff)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
